import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { PopupReportHistorialService } from '../../../../locations-map/services/Popup-Report-Historial.service';
import { IRouteMapRequest } from '../../../../routeMap/models/IRouteMapRequest';
import { GeoClustersFrecuencyPlacesService } from '../../../../locations-map/services/GeoClustersFrecuencyPlaces.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/geofences-map/services/Geofences.service';
import { FilterMapComponent } from 'src/app/features/locations-map/components/filters-map/filter-map.component';
import { PopupReportHistorialComponent } from 'src/app/features/locations-map/components/popup-report-historial/popup-report-historial.component';
import { LocationDTO } from 'src/app/features/locations-map/models/LocationDTO';
import { PanelDetailLocationsService } from 'src/app/features/locations-map/services/Panel-Detail-Locations.service';
import { PanelLocationsService } from 'src/app/features/locations-map/services/Panel-Locations.service';
import { ValetParkingService } from 'src/app/features/locations-map/services/ValetParking.service';
import { GroupStepRouteDTO } from 'src/app/features/routeMap/models/GroupStepRouteDTO';
import { ResumeRouteMapDTO } from 'src/app/features/routeMap/models/ResumeRouteMapDTO';
import { StepDetailsRouteDTO } from 'src/app/features/routeMap/models/StepDetailsRouteDTO';
import { PanelResumeRouteService } from 'src/app/features/routeMap/services/Panel-Resume-Route.service';
import { RouteFilterService } from 'src/app/features/routeMap/services/Route-Filter.service';
import { RouteMapService } from 'src/app/features/routeMap/services/Route-Map.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { FileUtilities } from '../../../helpers/utilities/FileUtilities';
import { MapService } from '../../../services/Map.service';
import { NotificationsToastService } from '../../../services/Notifications-Toast.service';
import { SignalUserService } from '../../../services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from '../../../services/Session.service';
import { SwalNotificationService } from '../../../services/SwalNotification.service';
import { IRequestMapRouteForm } from '../models/IRequestMapRouteForm';
import { PermissionFilterPipe } from '../../../pipes/Permission-filter.pipe';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit,OnDestroy {
  @ViewChildren('globalL, movimientosL, conduccionL, manejoL, movimientosR, conduccionR, manejoR') reportList: QueryList<any> = new QueryList();
  @ViewChildren('addGeofence, editGeofence, cloneGeofence, deleteGeofence') geofenceActionList: QueryList<any> = new QueryList();
  @ViewChildren('geoPFrecuencyL') geoprocessActionList: QueryList<any> = new QueryList();
  //inputs para el boton de reportes (default como true)
  @Input() reportes: boolean = true;
  //inputs para modificar opciones de reportes
  @Input() isRutas: boolean = false;
  @Input() isGlobal: boolean = false;
  @Input() identifier: any;
  @Input() isFromLocation: boolean = false;

  //inputs para la lista de excel
  @Input() btnDownExcel: boolean = false;
  @Input() isLocationFilter: boolean = false;
  @Input() filterLocationList: LocationDTO[] = [];
  @Input() selectedTabIndex: number;

  //inputs para geocercas
  @Input() editGeofences: boolean = false;
  @Input() isGeofenceDetails: boolean = false;
  @Input() geofenceGuid: string = "";

  //inputs y outputs para el filtro
  @Input() filtersObject: any;
  @Input() ApplyFilter: boolean = false;
  @Output() filterResponse = new EventEmitter<any>();

  //inputs para routes
  locationRequest: IRequestMapRouteForm = {
    vehiculo: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  @Input() isDetailLocations: boolean = false;

  //inputs para valet parking
  @Input() isValetParking: boolean = false;
  @Input() valetParkingGuid: string = "";
  @Output() valetParkingDeleteResponse = new EventEmitter<boolean>();
  @Output() valetParkingCreateResponse = new EventEmitter<any>();

  _hasReportsWithPermissions = false;
  subscription_findByIdentifier: Subscription;
  Subscription_AfterClosed: Subscription;
  suscription_openSecondaryMenu: Subscription;
  suscription_getReport: Subscription;
  suscription_getGroupByIdentifier: Subscription;
  suscription_postLocationsToExcel: Subscription;
  suscription_delete: Subscription;
  subscription_routeFilterService: Subscription;
  suscription_valetParkingDelete: Subscription;
  showReports : boolean = false;
  groupName: string;

  configDialog: MatDialogConfig = {
    panelClass: "dialog-responsive",
    disableClose: false,
    height: "fit-content",
    autoFocus: false,
    restoreFocus: false,
  }

  constructor(private popupReportHistorialService: PopupReportHistorialService,
              private notifyService: SwalNotificationService,
              private notifyToastService: NotificationsToastService,
              private sessionService: SessionService,
              public dialog: MatDialog,
              private panelLocationsService: PanelLocationsService,
              private panelDetalilService: PanelDetailLocationsService,
              private geofenceService : GeofencesService,
              private routeFilterService: RouteFilterService,
              private routeMapService: RouteMapService,
              private panelResumeRouteService: PanelResumeRouteService,
              private mapHelper: MapHelperService,
              private toastrService: ToastrService,
              private signalUserService: SignalUserService,
              private mapService: MapService,
              private valetParkingService: ValetParkingService,
              public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
              private permissionFilterPipe: PermissionFilterPipe) {    
                if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)         
                  this.sessionService.getCustomerId();
              }

  ngOnInit(): void {
    this.isFromLocation = (!this.isGlobal && !this.isRutas);
    this._hasReportsWithPermissions = this.hasReportsWithPermissions();
  }

  ngOnDestroy(): void{
    if (this.suscription_openSecondaryMenu)
    this.suscription_openSecondaryMenu.unsubscribe();
    if (this.suscription_getReport)
    this.suscription_getReport.unsubscribe();
    if (this.suscription_getGroupByIdentifier)
    this.suscription_getGroupByIdentifier.unsubscribe();  
    if (this.suscription_postLocationsToExcel)
    this.suscription_postLocationsToExcel.unsubscribe();  
    if (this.suscription_delete)
    this.suscription_delete.unsubscribe();  
    if(this.Subscription_AfterClosed)
    this.Subscription_AfterClosed.unsubscribe();
    if(this.subscription_findByIdentifier)
    this.subscription_findByIdentifier.unsubscribe();
    if(this.subscription_routeFilterService)
    this.subscription_routeFilterService.unsubscribe();
    if(this.suscription_valetParkingDelete)
      this.suscription_valetParkingDelete.unsubscribe();

    this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
  }

  onClickDownloadReportHistGlobal() {
    
    let dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);

    dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        
        this.suscription_getReport = this.popupReportHistorialService
          .getReportHist(
            res.formGroup.initialDate,
            res.formGroup.finalDate
          )
          .subscribe(
            (response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                FileUtilities.DownLoadFileV2(
                  response.file,
                  "ReporteMovimientosGlobal.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
              }else{
                this.notifyService.MessageInfo(
                  "El reporte no contiene información"
                );    
              }
              this.panelLocationsService.setLoading(false);
            }
            },
            (error) => {
              this.panelLocationsService.setLoading(false);
              this.notifyService.MessageInfo(
                "No se encontró información del reporte"
              );
            }
          );
      }
    });
  }

  ShowDownloadingMessage() {
    var resp = this.notifyService.MessageDownloading();
        resp.then(d=>{
        if(d.isConfirmed){
          this.notifyToastService.showInfoExtended("","Procesando solicitud de descarga...");
        }});
  }

  onClickReportMenuHistMov(){
    let dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
    dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        console.log("session service",this.sessionService);
        
        this.suscription_getReport = this.popupReportHistorialService
          .getReportHist(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe((response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                FileUtilities.DownLoadFileV2(
                  response.file,
                  "Reporte Historial de movimientos.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            (error) => {
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo(
                "No se encontró información del reporte"
              );
            }
          );
        // }
      }
    });
  }
  onClickReportMenuStats(){
    let dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
  
    dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        console.log("session service",this.sessionService);
        console.log("res",res.formGroup.initialDate);
        console.log("res 2",res.formGroup.finalDate);
        console.log("identifier",this.identifier);
        
         this.suscription_getReport = this.popupReportHistorialService
          .getReportStatistics(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe((response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                FileUtilities.DownLoadFileV2(
                  response.file,
                  "Reporte estadisticas de manejo.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            (error) => {
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo(
                "No se encontró información del reporte"
              );
            }
          );
        // }
      }
    });
  }
  onClickReportMenuHabit(){
    let dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
  
    dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();

        console.log("session service",this.sessionService);
        console.log("res",res.formGroup.initialDate);
        console.log("res 2",res.formGroup.finalDate);
        console.log("identifier",this.identifier);
        
       this.suscription_getReport = this.popupReportHistorialService
          .getReportHabits(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe((response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                let fileBase64: any = response.file;
                FileUtilities.DownLoadFileV2(
                  fileBase64,
                  "Reporte Habitos de conduccion.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            (error) => {
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo(
                "No se encontró información del reporte"
              );
            }
          );
        // }
      }
    });
  }

  // getExcel(){
  //   if (!this.isLocationFilter) {
  //     this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsTabToExcel(this.selectedTabIndex).subscribe((data) =>{
      
  //       if (data.isSuccess == true) {
  //         // Decodificar los datos que trae como string del servidor
  //         const byteCharacters = atob(data.result);
  //         const byteNumbers = new Array(byteCharacters.length);
  //         for (let i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }
  //         const byteArray = new Uint8Array(byteNumbers);
  
  //         const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = 'Lista_de_locacion.xlsx'; // Nombre del archivo según sea necesario
  //         document.body.appendChild(a);
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //         this.notifyService.MessageSuccessful(
  //           "Archivo Descargado",
  //           "Se han descargado los activos en un excel"
  //         );
  //       }
  //       else{
  //         this.notifyService.MessageError(
  //           "Archivo no descargado, No hay datos"
  //         );
  //       }
  //     });
  //   }else{
  //     this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsVinListToExcel(this.filterLocationList).subscribe((data) =>{
      
  //       if (data.isSuccess == true) {
  //         // Decodificar los datos que trae como string del servidor
  //         const byteCharacters = atob(data.result);
  //         const byteNumbers = new Array(byteCharacters.length);
  //         for (let i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }
  //         const byteArray = new Uint8Array(byteNumbers);
  
  //         const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = 'Lista_de_locacion.xlsx'; // Nombre del archivo según sea necesario
  //         document.body.appendChild(a);
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //         this.notifyService.MessageSuccessful(
  //           "Archivo Descargado",
  //           "Se han descargado los activos en un excel"
  //         );
  //       }
  //       else{
  //         this.notifyService.MessageError(
  //           "Archivo no descargado, No hay datos"
  //         );
  //       }
  //     });
  //   }
    
  // }

  openFilter(): void {
    console.log("filtersObject",this.filtersObject);
    
    let dialogRef = this.dialog.open(FilterMapComponent, {
      data: { filters: this.filtersObject.filters, selected: this.filtersObject.selected },
      disableClose: true,
      width: "40vw",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
    });
   this.Subscription_AfterClosed = dialogRef.afterClosed().subscribe((res) => {
      if (res.search) {
        this.filterResponse.emit(res);
      }
    });
  }

  getLocationRoute() {
    this.panelDetalilService.setLoading(true);
    this.subscription_findByIdentifier = this.routeFilterService
          .findByIdentifier(this.identifier)
          .subscribe((arg) => {
            if (this.identifier.length == 17) {
              this.locationRequest.vehiculo = arg.result[0];
              this.routeFilterService.setVehiculo( arg.result[0]);
            }
            console.log("buscando...");

            this.locationRequest.startDate = new Date();
            this.locationRequest.endDate = new Date();
            console.log("fechas inicio", this.locationRequest.startDate.toISOString());
            console.log("fechas fin", this.locationRequest.endDate.toISOString());
            console.log("request vehiculo identifier", this.locationRequest.vehiculo);
        
            if (
              this.locationRequest.vehiculo &&
              this.locationRequest.startDate &&
              this.locationRequest.endDate
            ) {
              try {
                const startDate = new Date(this.locationRequest.startDate);
                const endDate = new Date(this.locationRequest.endDate);
                startDate.setHours(this.locationRequest.startDate.getHours() - 6);
                endDate.setHours(this.locationRequest.endDate.getHours() - 6);
                var requestRouteMap: IRouteMapRequest = {
                  Identifier: this.locationRequest.vehiculo.identifier,
                  StartDate: this.locationRequest.startDate.toISOString(),
                  EndDate: this.locationRequest.endDate.toISOString(),
                  StartHour: null,
                };
        
                console.log("updating...");
        
                this.getRouteMapService(requestRouteMap);
              } catch (error) {
                // this.request.startDate = null;
                console.log(error);
                this.panelDetalilService.setLoading(false);
              }
            }else{
              this.panelDetalilService.setLoading(false);
            }
          });
    
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe(
      (resp) => {
        console.log(resp);
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            
            if (resumeRoute.cantStops != null && resumeRoute.cantStops != "0" ) {
              //Close Locations
              this.panelDetalilService.setLoading(false);
              this.panelLocationsService.setVisibilityPanel(false);
              this.panelDetalilService.setVisibilityPopup(false);
              this.signalUserService.UnsubscribeSignalUserIdentifierService(this.identifier);
              this.mapService.UpdateLayerGeoJson(
                "locationActiveSource",
                this.mapService.Empty_GeoJson
              );

              //open routes
              this.routeMapService.showRouteMapLayers();
              this.panelResumeRouteService.setVisibilityPopup(true);
              this.panelResumeRouteService.setResume(resumeRoute);
              this.panelResumeRouteService.setDetails(detailsRoute);
              this.panelResumeRouteService.setGrouped(groupedRoute);
              console.log("groupedRoute", groupedRoute);
              this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
              //this.panelResumeRouteService.setRequest(request);
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              
              this.panelDetalilService.setLoading(false);
              this.toastrService.info(
                "por favor acceda desde Rutas para filtrar por otro rango de fechas",
                "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
              );
            }
          } else {
            
            this.panelDetalilService.setLoading(false);
            this.toastrService.info(
              "por favor acceda desde Rutas para filtrar por otro rango de fechas",
              "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
            );
          }
        } else {
          this.panelDetalilService.setLoading(false);
          // this.toastrService.error("Internal Error", elements.errors.toString());
        }
      },
      (error) => {
        console.log("location route error",error);
        this.panelDetalilService.setLoading(false);
      }
    );
  }
 

  // onClickAddGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = "";
  //   this.panelAddGeofenceService.$isDuplicate = false;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   //seleccionar el panel de agregar geocerca
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickEditGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.panelAddGeofenceService.$isDuplicate = false;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   this.geofenceService.setVisiblePanelDetailGeofences(false);
  //   //seleccionar el componnte de edicion
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickDuplicateGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.panelAddGeofenceService.$isDuplicate = true;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   this.geofenceService.setVisiblePanelDetailGeofences(false);
  //   //seleccionar el componnte de edicion
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickDeleteGeofence(){
  //   var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar esta geocerca ?");
  //   resp.then((result) =>{
  //      if(result.value)
  //      {
  //         // window.open(urlb,'_blank');
  //         this.suscription_delete = this.geofenceService.delete(this.geofenceGuid).subscribe((data)=>{
  //           console.log("Data ",data);
  //           if(data.isSuccess == true){
  //             this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
  //             document.location.reload();
  //              }else{
  //             this.notifyService.MessageError("Problema al eliminar el registro");
  //              }
  //         });
  //       }
  //    }); 
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.geofenceService.deleteGeofence(this.geofenceGuid);
  // }

  ValetParking(){
    if (this.isValetParking) {
      this.suscription_valetParkingDelete = this.geofenceService.FullDelete(this.valetParkingGuid).subscribe((data)=>{
        if(data.isSuccess == true){
          this.notifyService.MessageSuccessful("Borrado","Valet Parking Borrado exitosamente");
          this.valetParkingDeleteResponse.emit(true);
        }else{
          this.notifyService.MessageError("Problema al eliminar el Valet Parking");
        }
      });
    }else{
      var dialog = this.valetParkingService.openDialog(this.identifier);
      dialog.afterClosed().subscribe((isCreated) => {
        if (isCreated)
          this.valetParkingCreateResponse.emit(isCreated);
      });
    }
  }

  openRecurrentPlaces(){
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(!this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible);
    if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = this.identifier;
    }else{
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    }
  }

  hasReportsWithPermissions(): boolean {
    if (!this.reportes) return false;
    
    if (this.isFromLocation) {
      return this.permissionFilterPipe.transform('Hist.Movimientos-L') || 
             this.permissionFilterPipe.transform('Habit.Conduccion-L') || 
             this.permissionFilterPipe.transform('Estad.Manejo-L');
    }
    
    if (this.isGlobal) {
      return this.permissionFilterPipe.transform('Hist.Global-L');
    }
    
    if (this.isRutas) {
      return this.permissionFilterPipe.transform('Hist.Movimientos-R') || 
             this.permissionFilterPipe.transform('Habit.Conduccion-R') || 
             this.permissionFilterPipe.transform('Estad.Manejo-R');
    }
    
    return false;
  }
}
